import { AccredibleObjectWithId } from './utils.model';

export interface SpotlightDirectory {
  id: number;
  name: string;
  domain: string;
  private: boolean;
  visible: boolean;
  published: boolean;
  eligible_profiles_count: number;
  visible_profiles_count: number;
  update_in_progress: boolean;
  eligibility_sources: SpotlightDirectoryEligibilitySource[];
  created_at: string;
}

export interface SpotlightDirectoryEligibilitySource {
  id: number;
  name: string;
  type: string;
}

export interface DirectorySettings {
  accredible_setup_complete?: boolean;
  id?: number;
  name: string;
  visible: boolean;
  published: boolean;
  domain: string;
  private: boolean;
  users_visible_by_default: boolean;
  credential_visibility: any;
  include_expired_credentials: boolean;
  filters: DefaultFilters;
  eligibility_sources: EligibilitySource[];
  all_eligible_groups_searchable: boolean;
  // In the response this is a SearchableGroup[] but in the request it needs to be a number[]
  searchable_groups: SearchableGroup[] | number[];
  custom_attributes: CustomAttribute[];
  display_user_additional_social_links: boolean;
  display_members_count?: boolean;
  spotlight_directory_evaluator_profiles_count?: {
    evaluators: number;
    owners: number;
  };
  directory_of_directories_enabled: boolean;
  directory_of_directories_members_count_enabled: boolean;
  owner_name?: string;
  owner_logo?: string;
  description?: string;
}

export interface SearchableGroup {
  id: number;
  name?: string;
  course_name: string;
}

export interface EligibilitySource extends AccredibleObjectWithId {
  id: number;
  name: string;
  course_name?: string;
  type?: EligibilityType;
  department?: DirectoryDepartment;
  organization?: {
    id: number;
    name: string;
  };
}

export enum CustomAttributeType {
  SELECT_ONE = 'select_one',
  SELECT_ANY = 'select_any',
  TEXT = 'text',
  BOOLEAN = 'boolean',
}

export interface CustomAttributeFilter {
  id: number;
  value: CustomAttributeValue;
}

export interface CustomAttribute {
  id: number;
  label: string;
  type: CustomAttributeType;
  searchable: boolean;
  value?: CustomAttributeValue;
  options?: CustomAttributeOption[];
  description?: string;
  // User value is used only on the Accounts property to provide the current value for the custom attribute
  user_value?: CustomAttributeUserValue;
}

export type CustomAttributeValue = string | boolean | number | number[];

export interface CustomAttributeUserValue {
  id: number;
  value: CustomAttributeValue;
  // Accounts only
  spotlight_directory_custom_attribute_id?: number;
}

export interface CustomAttributeOption {
  id: number;
  label: string;
  // The spotlight_directory_custom_attribute_id property is only used on Accounts
  // to update the users custom attribute value
  spotlight_directory_custom_attribute_id?: number;
}

export interface DirectoryDepartment {
  id: number;
  name: string;
}

export interface DefaultFilters {
  name: boolean; // profile name
  recipient_name: boolean;
  recipient_email: boolean;
  recipient_id: boolean;
  credential_uuid: boolean;
  credential_api_id: boolean;
  groups: boolean; // credential
  location: boolean;
  skills: boolean;
  availability: boolean;
  categories: boolean;
  organizations: boolean; // department

  [key: string]: boolean;
}

export enum EligibilityType {
  ORGANIZATION = 'Organization',
  GROUP = 'Group',
}
